var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"shadow-none text-dark eqify-menu-item d-flex align-items-center",attrs:{"to":_vm.to,"variant":"light","block":""}},[_c('div',{staticClass:"p-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }